import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
//import 'slick-carousel/slick/slick';
//import 'hc-sticky/dist/hc-sticky';
import 'owl.carousel2/dist/owl.carousel';
import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js"; 


$(document).foundation();

$(document).ready(function () {


    var direction = $('html').css("direction").toLowerCase() === 'rtl' ? 'right' : 'left';
    var direction_boolean = $('html').css("direction").toLowerCase() === 'rtl';


    // var stickyHeader = new hcSticky('#sticky-header', {
    //     stickTo: '#main-wrap',
    //     onStart: function () {
    //         $('.canvas-panel').css('top', $('.main-header-inner').outerHeight());
    //     },
    //     onStop: function () {
    //         $('.canvas-panel').css('top', $('#main-header').outerHeight());
    //     }
    // });

    //sticky header

    //  if ($('#main-header').length > 0) {
    //     var stickyBlock = new hcSticky('#sticky-header', {
    //         stickTo: 'main',
    //         stickyClass: 'hc-sticky',
    //     });
    // }


    if ($('#t-speaker-slider').length > 0) {
        $('#t-speaker-slider').owlCarousel({
            loop: true,
            margin: 0,
            rtl: false,
            responsiveClass: false,
            nav: false,
            dots: false,
            // autoplay:true,
            // autoplayTimeout:1600,
            responsive: {
                0: {
                    items: 3,

                },
                768: {
                    items: 5
                },
                1000: {
                    stagePadding: 27,
                    items: 5,
                }
            }
        });

        if (Foundation.MediaQuery.is('small only')) {
            $('#t-speaker-slider').trigger('destroy.owl.carousel'); 
        }
        
        $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
            // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
           
        });
    }

    if ($('#speaker-slider').length > 0) {
        $('#speaker-slider').owlCarousel({
            loop: true,
            margin: 0,
            responsiveClass: true,
            nav: false,
            rtl: true,
            dots: false,
            // autoplay:true,
            // autoplayTimeout:1600,
            responsive: {
                0: {
                    items: 3
                },
                768: {
                    items: 5
                },
                1000: {
                    stagePadding: 27,
                    items: 5,
                }
            }
        });

        if (Foundation.MediaQuery.is('small only')) {
            $('#speaker-slider').trigger('destroy.owl.carousel'); 
        }
    } 

    // if ($('.hero').length > 0){
    //     function fitHeaderHeight(){
    //         // get window heigth
    //         var windowHeight = ($(window).height() - $("header").height()) + "px";

    //         $(".hero").css("height", windowHeight);
    //     }

    //     fitHeaderHeight();

    //     $( window ).on('resize', function() {
    //         fitHeaderHeight();
    //     });
    // }


    /** ====================== START: GOOGLE MAPS ============================  **/
    // if ($('#map-canvas').length > 0){
    //     var map;

    //     function initialize() { 
    //     var myLatlng = new google.maps.LatLng(40.75404328518921, -73.97747627174994);
    //     var mapOptions = {
    //         zoom: 20,
    //         center: myLatlng,
    //         styles:  [
    //             {
    //               "featureType": "landscape.man_made",
    //               "elementType": "geometry.fill",
    //               "stylers": [
    //                 {
    //                   "color": "#fafafa"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "landscape.man_made",
    //               "elementType": "geometry.stroke",
    //               "stylers": [
    //                 {
    //                   "color": "#c7c7c7"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "landscape.man_made",
    //               "elementType": "labels.text",
    //               "stylers": [
    //                 {
    //                   "color": "#626060"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "landscape.natural.landcover",
    //               "elementType": "geometry.fill",
    //               "stylers": [
    //                 {
    //                   "color": "#ababab"
    //                 },
    //                 {
    //                   "weight": 1
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "landscape.natural.landcover",
    //               "elementType": "geometry.stroke",
    //               "stylers": [
    //                 {
    //                   "color": "#ababab"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "landscape.natural.terrain",
    //               "elementType": "geometry.fill",
    //               "stylers": [
    //                 {
    //                   "color": "#dedede"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.attraction",
    //               "elementType": "geometry.fill",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.business",
    //               "stylers": [
    //                 {
    //                   "visibility": "simplified"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.business",
    //               "elementType": "geometry.fill",
    //               "stylers": [
    //                 {
    //                   "color": "#cfcfcf"
    //                 },
    //                 {
    //                   "visibility": "simplified"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.business",
    //               "elementType": "geometry.stroke",
    //               "stylers": [
    //                 {
    //                   "color": "#b0b0b0"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.business",
    //               "elementType": "labels.icon",
    //               "stylers": [
    //                 {
    //                   "color": "#cfcfcf"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.business",
    //               "elementType": "labels.text",
    //               "stylers": [
    //                 {
    //                   "color": "#858585"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.government",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.medical",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.park",
    //               "elementType": "labels.text",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.place_of_worship",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.school",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             },
    //             {
    //               "featureType": "poi.sports_complex",
    //               "stylers": [
    //                 {
    //                   "visibility": "off"
    //                 }
    //               ]
    //             }
    //           ]
    //     };
    //     map = new google.maps.Map(document.getElementById('map-canvas'),
    //         mapOptions);

    //     var marker = new google.maps.Marker({
    //         position: myLatlng,
    //         map: map,
    //     });

    //     }

    //     google.maps.event.addDomListener(window, 'load', initialize);
    // }

    /** ====================== END: GOOGLE MAPS ============================  **/

});